import './css/Experience.css';
import { translateExperiencias } from '../../data/translateExperience';

// Dicionário local para traduzir o título da seção
const uiText = {
  pt: {
    titulo: "EXPERIÊNCIA",
  },
  en: {
    titulo: "EXPERIENCE",
  }
};

function Experience({ language }) {
    const ui = uiText[language];
    
    // Pega o array de experiências baseado no idioma atual (pt ou en)
    const experiencias = translateExperiencias[language];

    return (
        <section className="experience-section" id="experience">
            <div className='box-title-section'>
                <p className='back-legend'>{ui.titulo}</p>
                <h2 className='front-legend2'>{ui.titulo}</h2>
            </div>
            
            <div className="experience-container">
                <div className="experience-grid">
                    
                    {/* --- COLUNA: EXPERIÊNCIA --- */}
                    <div className="timeline-column">
                        <div className="timeline-header">
                        </div>
                        
                        <div className="timeline">
                            {/* O .map percorre o array e renderiza um bloco para cada experiência */}
                            {experiencias.map((xp, index) => (
                                <div className="timeline-item" key={xp.id}>
                                    
                                    {/* Lógica condicional: O item 0 (mais recente) recebe a cor 'primary', os demais recebem 'gray' */}
                                    <div className={`timeline-dot ${index === 0 ? 'dot-primary' : 'dot-gray'}`}></div>
                                    <span className={`timeline-date ${index === 0 ? 'date-primary' : 'date-gray'}`}>
                                        {xp.periodo}
                                    </span>
                                    
                                    <h4 className="timeline-role">{xp.cargo}</h4>
                                    <div className="timeline-company">{xp.empresa}</div>
                                    <p className="timeline-desc">
                                        {xp.descricao}
                                    </p>
                                    
                                </div>
                            ))}
                        </div>
                        
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Experience;